export default __webpack_public_path__ + "static/media/AG14.542adc4a.mp3";